module.exports = __webpack_public_path__ + "media/fujin.339a11f1.wav";